import React from 'react'

const SecondLoader = () => {
    return (
        <div className='sp-second-loader-container'>
            <span className="sp-second-loader"></span>
       </div>
    )
}

export default SecondLoader